import { Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { BaseFieldComponent } from '../base-field.component';

@Component({
    selector: 'app-text-field',
    imports: [IonicModule],
    template: `
        @if (readonly) {
            <ion-item lines="none">
                <ion-label>
                    <p class="field-label">{{ field.label }}</p>
                    <p class="field-value">{{ value || '-' }}</p>
                </ion-label>
            </ion-item>
        } @else {
            <ion-item>
                <ion-label position="stacked">{{ field.label }}</ion-label>
                <ion-input
                    [placeholder]="field.placeholder || ''"
                    [value]="value"
                    [required]="isRequired"
                    (ionInput)="onInput($event)">
                </ion-input>
            </ion-item>
            @if (field.helpText) {
                <ion-note class="field-help">{{ field.helpText }}</ion-note>
            }
        }
    `,
    styles: [`
        .field-help {
            padding: 4px 16px;
            font-size: 12px;
        }
        .field-label {
            color: var(--ion-color-medium);
            font-size: var(--fs-400);
        }
        .field-value {
            white-space: pre-wrap;
            font-size: var(--fs-400);
        }
    `]
})
export class TextFieldComponent extends BaseFieldComponent {
    initialize(value: any): void {
        this.value = value ?? '';
    }

    serialize(): any {
        return this.value;
    }

    onInput(event: any): void {
        this.emitChange(event.detail.value);
    }
}
